// extracted by mini-css-extract-plugin
export default {"wrapper":"qrButton__wrapper--XSD9Z"};